(function (Drupal) {
  Drupal.behaviors.scrollIndicator = {
    attach: function(context,settings) {
      window.onload = () => {
        const progress = () => {
          const line = document.createElement('div')
          line.className = 'progress-scroll'
          document.body.prepend(line)
          const progressWidth = () => {
            return line.style.width = Math.floor(window.pageYOffset / (document.documentElement.scrollHeight - window.innerHeight) * 100) + '%'
          }
          progressWidth()
          document.addEventListener('scroll', throttle(progressWidth, 64))
          window.addEventListener('resize', throttle(progressWidth, 64))
        }
        progress()
      }
      const throttle = (func, ms) => {
        let locked = false
        return () => {
          if (locked) return
          locked = true
          setTimeout(() => {
            func()
            locked = false
          }, ms)
        }
      }
    }
  };
})(Drupal);
